export const ru = {
    'message-failure': 'Не удалось пригласить пользователей в организацию',
    'message-failure-users': 'Не удалось пригласить в организацию: ',
    'message-success': 'Приглашены в организацию:'
};
